import React from 'react';
import { Wrench } from 'lucide-react';

const MAINTENANCE_UNTIL = process.env.REACT_APP_MAINTENANCE_UNTIL || '';

export const MaintenancePage: React.FC = () => (
  <div
    data-testid="maintenance-page"
    className="flex flex-col items-center justify-center text-center"
    style={{ minHeight: '100vh', background: '#F8FAFC' }}
  >
    <div className="flex flex-col items-center">
      {/* アイコン */}
      <div
        style={{
          width: 80,
          height: 80,
          borderRadius: 16,
          background: '#E6F4F3',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 24,
        }}
      >
        <Wrench size={32} style={{ color: '#0a7a72' }} />
      </div>

      <h1 className="font-bold mb-3" style={{ fontSize: 22, color: '#0F172A' }}>
        ただいまメンテナンス中です
      </h1>

      <p
        className="leading-relaxed mb-3"
        style={{ fontSize: 14, color: '#64748B', maxWidth: 380 }}
      >
        より良いサービスをご提供するため、システムメンテナンスを実施しています。ご不便をおかけして申し訳ございません。
      </p>

      {MAINTENANCE_UNTIL && (
        <p className="font-semibold" style={{ fontSize: 14, color: '#0a7a72' }}>
          完了予定: {MAINTENANCE_UNTIL} 頃
        </p>
      )}
    </div>
  </div>
);
